<template>
    <div>
        <div class="comment_conversion">
            <div v-if="ajaxCallInProgress" class="text-center d-flex align-items-center justify-content-center font-weight-bold" style="background-color: #ffffff !important;height: 100vh !important;">
                <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
                <!-- <div>
                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center"/>
                </div> -->
            </div>
            <!-- <div v-if="ajaxCallInProgress" class="checkoutLoader">
                <div class="LoaderPlacement">
                        <div class="digi-table-loader">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                </div>
            </div> -->
            <div v-if="!ajaxCallInProgress && email_show.length == 0" class="text-center font-weight-bold">
                <div>No Emails Found</div>
            </div>
            <div v-else class="" v-for="(email,index) in email_show" :key="index">
                <div class=" justify-content-center email_event mt-2">
                    <span class="">  
                        <!-- <span>{{formatDate(email.created_date)}}</span> -->
     
                        <span class="fw-600 fs-16">Date: {{dateFormat(email.created_date).split(' ')[0]}}</span> 
                        <span class="fw-600 fs-16"> {{dateFormat(email.created_date).split(' ')[1] + ' ' +  dateFormat(email.created_date).split(' ') [2] }}</span> 
                        <span class="fw-600 fs-16"> {{email.created_date.slice(11)}}</span>
                        <!-- <span>{{email.created_date.split(' ')[3] + ' ' +  email.created_date.split(' ') [4] }}</span>   -->
                    </span>
                </div>
                <div class="mt-4" >
                    <div class="d-flex flex-column">
                        <div class="d-flex">
                            <div class="profileCircle">
                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" alt="">
                            </div>
                            <div class="d-flex flex-column" >
                                <span class="fs-15 fw-600">{{email.from_name}}</span>
                                <span class="fs-14">{{email.from_email}}</span>
                            </div>
                        </div>
                        <!-- <span class="curve_email"></span> -->
                        <div class="mail_template mr-1">
                            <div style="border-bottom:0.5px solid #bfc1c3" class="bg-white">
                                <p class="ml-3 pt-4 fw-500">Subject: {{email.subject}}</p>
                            </div>
                            <div slot="md-expand" v-if="email.is_html_content">
                                <div class="md-card-list-item-content-wrapper" style="display: block; opacity: 1;padding: 10px 20px; box-shadow: 0px 0px 0px 0.5px #aaaaaa;border-radius: 5px">
                                    <div class="md-card-list-item-content">
                                        <p class="p-description-mail" v-html="email.body">
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p v-html="email.body"></p>
                            </div>
                        </div>
                        <!-- <div class="d-flex justify-content-end p-3 mr-5" v-if="replyBtnhide">
                            <button class="btn btn-secondary btn-smm ml-2 fs-14" @click="replyMail()">
                            <i class="icon icon-reply text-danger fs-18 pb-1"></i>
                                Reply
                            </button>
                        </div> -->
                        <div>
                            <div class="" v-if="replyShow">
                                <!-- <div class="d-flex align-items-center mt-4" >
                                    <div class="profileCircle">
                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png" alt="">
                                    </div>
                                    <div class="d-flex flex-column">
                                        <span class="fs-16 fw-600">HelpDesk</span>
                                        <span>helpdesk@digicollect.com</span>
                                    </div>
                                </div> -->
                                <div>
                                    <div class="ticket_reply pointer mt-7 mb-5 mr-1 ">
                                        <div>
                                            <!-- <input class="inputFieldNew to_reply" v-model="toreply" type="text" placeholder="To" />
                                            <input class="inputFieldNew to_reply" v-model="ccreply" type="text" placeholder="Cc" />
                                            <input class="inputFieldNew to_reply" v-model="bccreply" type="text" placeholder="Bcc" /> -->
                                            <div class="">
                                                <multiselect
                                                    v-validate="'required'"
                                                    class="diginew-multiselect approval-manager filter-multiple mt-2"
                                                    name="ticketType"
                                                    v-model="toEmail"
                                                    label="name"
                                                    :allow-empty="false"
                                                    :multiple="false"
                                                    :options="users"
                                                    :searchable="true"
                                                    :close-on-select="true"
                                                    :show-labels="false"
                                                    placeholder="Enter Email Id"
                                                    :loading="loading" @search-change="getAllUsers"
                                                    @remove="removeTo" :blockKeys="['Delete']"
                                                >
                                                <template slot="tag" slot-scope="{ option }">
                                                    <span class="custom__tag">
                                                    <span class="filterSelectedNameEmail">{{ option.name }}</span>
                                                        <span class="custom__remove pointer" @click="removeTo(option)">
                                                        <i class="icon icon-close fs-16 text-white"></i>
                                                        </span>
                                                    </span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfUsers" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                                </multiselect>
                                            </div>
                                            <div class="">
                                                <multiselect
                                                    class="diginew-multiselect approval-manager filter-multiple mt-2"
                                                    v-model="ccEmail"
                                                    label="name"
                                                    :multiple="true"
                                                    :options="users"
                                                    :searchable="true"
                                                    :close-on-select="false"
                                                    :show-labels="false"
                                                    placeholder="Search and Select cc Email Id"
                                                    :loading="loading" @search-change="getAllUsers"
                                                    @remove="removeCC" :blockKeys="['Delete']"
                                                >
                                                <template slot="tag" slot-scope="{ option }">
                                                    <span class="custom__tag">
                                                    <span class="filterSelectedNameEmail">{{ option.email }}</span>
                                                        <span class="custom__remove pointer" @click="removeCC(option)">
                                                        <i class="icon icon-close fs-16 text-white"></i>
                                                        </span>
                                                    </span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfUsers" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                                </multiselect>
                                            </div>
                                            <div class="">
                                                <multiselect
                                                    class="diginew-multiselect approval-manager filter-multiple mt-2"
                                                    v-model="bccEmail"
                                                    label="name"
                                                    :multiple="true"
                                                    :options="users"
                                                    :searchable="true"
                                                    :close-on-select="false"
                                                    :show-labels="false"
                                                    placeholder="Search and Select bcc Email Id"
                                                    :loading="loading" @search-change="getAllUsers"
                                                    @remove="removeBCC" :blockKeys="['Delete']"
                                                >
                                                <template slot="tag" slot-scope="{ option }">
                                                    <span class="custom__tag">
                                                    <span class="filterSelectedNameEmail">{{ option.email }}</span>
                                                        <span class="custom__remove pointer" @click="removeBCC(option)">
                                                        <i class="icon icon-close fs-16 text-white"></i>
                                                        </span>
                                                    </span>
                                                </template>
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfUsers" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                                </multiselect>
                                            </div>
                                            <vue-editor
                                                ondrop="return false;"
                                                class="mt-2"
                                                name="ticket_decription"
                                                v-model="reply"
                                                placeholder="Reply Here..."
                                                v-validate="'required'"
                                            ></vue-editor>
                                        </div>
                                    </div>
                                    <span id="file_attach">
                                        <div>
                                            <label class="chooseFile mt-1">
                                                <input type="file" id="multiple" multiple @change="uploadAttachment" accept=".pdf,.doc,.xls,image/*">
                                                <img class="mr-1 pointer" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/attach_file.svg" alt="">
                                            </label>
                                            <div class="example-full">
                                                <div class="btn-group" style="display: none;">
                                                    <file-upload
                                                        class="btn btn-primary dropdown-toggle"
                                                        :multiple="multiple"
                                                        :directory="directory"
                                                        :size="size || 0"
                                                        :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                                                        :headers="headers"
                                                        :data="data"
                                                        :drop="drop"
                                                        :drop-directory="dropDirectory"
                                                        :add-index="addIndex"
                                                        v-model="temp_attachments"
                                                        @input-file="inputFile"
                                                        ref="upload"
                                                        webkitdirectory mozdirectory>
                                                        <i class="icon icon-plus"></i>
                                                        Select
                                                    </file-upload>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <img class="pointer" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/insert_link.svg" alt="">
                                        </div>
                                    </span>
                                    <div class="d-flex flex-wrap align-items-center">
                                        <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment,index) in attachments" :key="index">
                                            <div class="d-flex align-items-center mt-2 p-2" style="background-color:#bbd9fd">
                                                <div class="d-flex align-items-center" style="width:90%">
                                                    <div>
                                                        <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                        <img v-else-if="attachment.name.endsWith('.png')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                        <img v-else-if="attachment.name.endsWith('.jpg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                        <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                        <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                        <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                    </div>
                                                    <div class="col">
                                                        <div class="d-flex justify-content-between">
                                                            <el-tooltip :content="attachment.name" placement="top">
                                                                <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                    {{attachment.name}}
                                                                </div>
                                                            </el-tooltip>
                                                            <!-- <div class="text-right" v-if="attachment.url == undefined" @click="getResumableURL(attachment)">
                                                                <i class="icon icon-refresh text-danger fs-16"></i>
                                                            </div> -->
                                                        </div>
                                                        <div v-if="attachment.uploading || attachment.url == undefined">
                                                            <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                        </div>    
                                                        <div class="d-flex justify-content-between">
                                                            <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}...</div>
                                                            <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                            <div class="fw-500" v-if="attachment.size">({{attachment.size | prettyBytes}})</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="pointer ml-3" style="width:10%" @click="deleteAttachment(attachment,index)">
                                                    <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                    <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url && attachment.uploading == false"></i>
                                                </div>
                                            </div>
                                        </div>    
                                    </div>
                                    <div class="d-flex justify-content-end mt-10 mb-3 mr-2">
                                        <button type="button" class="btn btn-danger-new" style="box-shadow: none;" @click="discardMail()">
                                            Discard
                                        </button>
                                        <button type="button" class="btn btn-green ml-3 mr-5" style="box-shadow: none;" @click="mailSend()">
                                            Send
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
import attachments from "../mixins/attachments.js";
import ticket from '../mixins/ticket.js';
import FileUpload from 'vue-upload-component';
import { SweetModal } from 'sweet-modal-vue';
import convert from '../mixins/convert.js';
export default {
    props:['ticket_id', 'showDetails'],
    mixins: [attachments,ticket,convert],
    components:{
        VueEditor,
        FileUpload,
        SweetModal
    },
    data(){
        return{
            mail_notes:'',
            attachments:[],
            search_key:'',
            emails:[],
            reply:'',
            replyShow:false,
            replyBtnhide:true,
            toEmail:'',
            to_email_options:[],
            ccEmail:[],
            cc_email_options:[],
            bccEmail:[],
            bcc_email_options:[],
            email_show:[],
            ajaxCallInProgress:false,
            temp_attachments:[],
            accept: '*',
            extensions: '*',
            size: 1024 * 1024 * 10,
            multiple: true,
            directory: true,
            drop: true,
            dropDirectory: true,
            addIndex: false,
            thread: 3,
            name: 'file',
            postAction: '/upload/post',
            putAction: '/upload/put',
            headers: {
                'X-Csrf-Token': 'xxxx',
            },
            data: {
                '_csrf_token': 'xxxxxx',
            },
            autoCompress: 1024 * 1024,
            loading:false,
            scrollable:false,
            temp_users:[],
            count:0,
            visible:false,
            users:[],
            list_users:[],
            success_msg:'',
            warning_msg:''
        }
    },
    methods:{
        removeTo(option){

        },
        removeBCC(option){
            this.bccEmail.forEach((el,index)=>{
                if(el.email == option.email){
                    this.bccEmail.splice(index,1)
                }
            })
        },
        removeCC(option){
            this.ccEmail.forEach((el,index)=>{
                if(el.email == option.email){
                    this.ccEmail.splice(index,1)
                }
            })
        },
        replyMail(){
            this.replyShow = true
            this.replyBtnhide = false
        },
        discardMail(){
            this.replyShow = false
            this.replyBtnhide = true
        },
        mailSend(){
            this.$validator.validateAll().then(result => {
                if (result == true){
                    this.confirmReply()
                }else{
                    this.$toasted.global.error("Please Fill All The Required Fields")
                }
            })
        },
        async confirmReply(){
            try {
                let res = await this.replytoEmail(this.create_json)
                this.success_msg = res.response.success_message
                this.getReplyMail()
                this.discardMail()
                this.reply = ''
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                }, 3000);
            } catch (reason) {
                this.warning_msg = reason
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                }, 3000);
            }
        },
        async getAllUsers(search_key){
            try {
                this.loading = true
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let response = await this.getUserEmails(params)
                this.list_users = response.response.emails
                this.list_users.forEach((el,index)=>{
                    let value = {
                        email:el.email_id,
                        name:el.name
                    }
                    this.users.push(value)
                })
                this.count = this.temp_users.length
                this.loading = false
                this.scrollable = false
            } catch (reason) {
                
            }
        },
        async reachedEndOfUsers(reached){
            this.visible = reached
            if (reached) {
                if (this.scrollable == false) {
                    this.loading = true
                    let params ={
                        skip:this.count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserEmails(params)
                    this.temp_users = response.response.emails.length;
                    if (response.response.skip == this.count) {
                        if (this.temp_users > 0) {
                            let tempFiles = response.response.emails;
                            tempFiles.forEach(el => {
                                this.list_users.push(el);
                                this.list_users.forEach((el,index)=>{
                                    let value = {
                                        email:el.email_id,
                                        name:el.name
                                    }
                                    this.users.push(value)
                                })
                            });
                            this.count += response.response.emails.length;
                            this.loading = false
                        } else {
                            this.scrollable = true
                            this.loading = false
                        }
                    }
                    this.loading = false
                }
            }
        },
        async getReplyMail(){
            try {
                this.ajaxCallInProgress = true
                let params = {
                    ticket_id:this.showDetails.ticket_id
                }
                let res = await this.getReplyEmails(params)
                this.email_show = res.response
                this.email_show.forEach((el,index)=>{
                    this.toEmail = {
                        email:el.to_email,
                        name:el.to_name
                    }
                })
                this.ajaxCallInProgress = false
            } catch (reason) {
                console.log(reason)
            }
        },
        deleteAttachment(attachment,index){
            this.attachments.forEach((el,elindex)=>{
                if(el.url == attachment.url){
                    this.attachments.splice(elindex,1)
                }
            })
        },
        inputFile(newFile, oldFile) {
            this.temp_attachments = []
            if (newFile && oldFile) {
                if (newFile.active && !oldFile.active) {
                if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
                    this.$refs.upload.update(newFile, { error: 'size' })
                }
                }
                if (newFile.progress !== oldFile.progress) {
                }
                if (newFile.error && !oldFile.error) {
                }
                if (newFile.success && !oldFile.success) {
                }
            }
            if (!newFile && oldFile) {
                if (oldFile.success && oldFile.response.id) {
                }
            }
            if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                if (this.uploadAuto && !this.$refs.upload.active) {
                this.$refs.upload.active = true
                }
            }
            this.input_file = newFile.file
            this.uploadAttachment(event)
        },
    },
    computed:{
        // reply_json(){
        //     return{
        //         toreply:this.to_email,
        //         ccreply:this.cc_list,
        //         bccreply:this.bcc_list,
        //         attach_files:this.attachments,
        //     }
        // }
    },
    async mounted(){
        this.getReplyMail()
    },
    computed:{
        create_json(){
            if(this.email_show && this.email_show.length){
                return{
                    attachments:this.attachments,
                    bcc_list:this.bccEmail,
                    cc_list:this.ccEmail,
                    email_body:this.reply,
                    from_email:{
                        name:this.email_show[0].from_name,
                        email:this.email_show[0].from_email
                    },
                    replied_to:this.email_show[0]._id,
                    subject:this.email_show[0].subject,
                    ticket_id:this.showDetails.ticket_id,
                    to_email:this.toEmail
                }
            }
        }
    }
}
</script>
<style scoped>
.comment_conversion{
    padding: 10px 0px 10px 15px;
    border-bottom: none;
    /* border-top: 1px solid #aac6ee; */
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    max-height: 100%;
    overflow-y: scroll;
}
.unfinishedCircle {
  background: #005dae;
  border-radius: 50%;
  height: 75px;
  width: 75px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  margin-right: 20px;
}
.profileCircle  img{
  height: 50px;
  width: 50px;
  margin-right: 20px;
}
.mail_template{
    /* background-color: #f2f3f5; */
    border-radius: 10px;
}
.mail_reply{
    background-color: #f2f3f5;
    border-radius: 10px;
}
.curve_email{
    border: solid transparent;
    border-top-color: transparent;
    border-width: 13px;
    border-bottom-color: #f2f3f5;
    width: 5px;
    border-radius: 0px;
    margin-left: 10px;
}
.ticket_reply{
    border-radius: 10px; 
    box-shadow: -1.5px 2.5px 3px 0 rgba(0, 0, 0, 0.16);
    background-color: #f2f3f5;
}
#file_attach{
    position: relative;
    bottom: 260px;
    left: 670px;
    display: flex;
    align-items: center;
    width: 50px;
}
.to_reply{
    border: none !important;
    border-bottom: 1px solid #bfc1c3 !important;
    border-radius: 0px !important;
    margin-top: 0px !important;
}
.p-description-mail {
    white-space: normal !important;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    color: #4e5764;
    margin-bottom: 30px;
    /* padding-left: 32px; */
}
.p-description-mail {
    overflow-y: visible !important;
    overflow-x: scroll;
}
.email_line .email_event:before,
.email_line .email_event:after {
    position: absolute;
    display: block;
    top: 0;
}
.email_line .email_event .unfinishedCircle {
  background: #005dae;
  border-radius: 50%;
  height: 75px;
  width: 75px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  margin-right: 20px;
  position: relative;
  right: 49px;
}
</style>